import React from 'react';

export interface IconProps {
    onClick?: () => void;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
    active?: boolean;
    className?: string;
    size?: number;
    padding?: number;
    selectable?: boolean;
    darkMode?: boolean;
}

const Icon: React.FC<IconProps & { iconName: string }> = ({
    iconName,
    onClick,
    active = false,
    darkMode = false,
    onMouseEnter,
    onMouseLeave,
    className,
    size = 5,
    padding = 2,
    selectable = false,
}) => {
    const iconUrl = `/icons/${iconName}.svg`;
    const shouldApplyFilter = active && (iconName !== 'logo-glow' && iconName !== 'logo');

    return (
        <div
            className={`cursor-pointer ${className}`}
            style={{ padding: `${padding * 0.25}rem` }}
            onClick={selectable ? onClick : undefined}
            onMouseEnter={selectable ? onMouseEnter : undefined}
            onMouseLeave={selectable ? onMouseLeave : undefined}
        >
            <img
                src={iconUrl}
                alt={`${iconName} icon`}
                className={`${shouldApplyFilter ? (darkMode ? 'filter invert brightness-0' : 'filter brightness-0') : ''}`}
                style={{ height: `${size * 0.25}rem`, width: `${size * 0.25}rem` }}
            />
        </div>
    );
};

const icon = (name: string): React.FC<IconProps> => (props) => <Icon iconName={name} {...props} />;

export const AiTechIcon = icon('ai-tech');
export const ArchiveAltIcon = icon('archive-alt');
export const BinIcon = icon('bin');
export const BookmarkIcon = icon('bookmark');
export const CalendarIcon = icon('calendar');
export const CameraAltIcon = icon('camera-alt');
export const CardViewIcon = icon('card-view');
export const CheckCircleIcon = icon('check-circle');
export const ChevronRightIcon = icon('chevron-right');
export const CloseIcon = icon('close');
export const ColorPalleteIcon = icon('color-pallete');
export const CopyLIcon = icon('copy-l');
export const DocsIcon = icon('docs');
export const EnvelopeIcon = icon('envelope');
export const EyeOffIcon = icon('eye-off');
export const FlashColorIcon = icon('flash-color');
export const LatestIcon = icon('latest');
export const LayersIcon = icon('layers');
export const LinkIcon = icon('link');
export const ListViewIcon = icon('list-view');
export const LockIcon = icon('lock');
export const LogoGlowIcon = icon('logo-glow');
export const LogoIcon = icon('logo');
export const LogoutAltIcon = icon('logout-alt');
export const MagicWandIcon = icon('magic-wand');
export const MoreVrIcon = icon('more-vr');
export const NotificationIcon = icon('notification');
export const PlusCircleIcon = icon('plus-circle');
export const PlusIcon = icon('plus');
export const ProfileIcon = icon('profile');
export const RefreshIcon = icon('refresh');
export const SearchIcon = icon('search');
export const SettingsIcon = icon('settings');
export const SidebarCloseIcon = icon('sidebar-close');
export const SmileIcon = icon('smile');
export const SortArrowDownIcon = icon('sort-arrow-down');
export const TagIcon = icon('tag');
export const TimeCircleIcon = icon('time-circle');
export const UploadIcon = icon('upload');
